/* eslint-disable no-undef */

// polyfills for IE11 issue with Element.matches not found
if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector
}
